import styled, { css } from 'styled-components';

import { Styled as EditorStyled } from '@xing-com/crate-articles-article-editor';
import { Flag } from '@xing-com/flag';
import { mediaConfined, mediaSmallOrTiny } from '@xing-com/layout-tokens';
import {
  scale110,
  scale130,
  scale140,
  scale150,
  scale410,
  space3XL,
  spaceS,
  spaceXL,
  spaceXXL,
} from '@xing-com/tokens';
import { BodyCopy, Hero } from '@xing-com/typography';

const ArticleContentContainer = styled.div`
  margin-bottom: ${space3XL};
`;

const MembershipFlag = styled(Flag)`
  margin-bottom: ${spaceS};
`;

const ArticleHeadline = styled(Hero)`
  font-size: ${scale140};
  line-height: ${scale150};
  margin-bottom: ${spaceXXL};

  @media ${mediaSmallOrTiny} {
    font-size: ${scale130};
    margin-bottom: ${spaceXL};
  }
`;

const ArticleSubtitleCopy = styled(BodyCopy)`
  font-size: ${scale110};
  margin-bottom: ${spaceXXL};

  @media ${mediaSmallOrTiny} {
    font-size: ${scale110};
  }
`;

const ContentContainer = styled.div<{ hasPaywall?: boolean }>`
  position: relative;

  ${({ hasPaywall }) =>
    hasPaywall &&
    css`
      min-height: 500px;

      @media ${mediaConfined} {
        min-height: ${scale410};
      }
    `};

  .tiptap {
    ${EditorStyled.EditorStyle}
  }
`;

export const Styled = {
  ArticleContentContainer,
  MembershipFlag,
  ArticleHeadline,
  ArticleSubtitleCopy,
  ContentContainer,
};
